// extracted by mini-css-extract-plugin
export default {"familyItem":"tab_familyItem__8NNQE","familyTitle":"tab_familyTitle__7Hp32","CardOfferItem":"tab_CardOfferItem__dWxh3"};